import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Languages } from "lucide-react";
import { http, formatApiError } from "@/lib/api";
import { Switch } from "@/components/ui/switch";

export const SpanishDefault = ({ sid, name }) => {
  const [on, setOn] = useState(null);
  useEffect(() => { http.get(`/students/${sid}/spanish`).then((r) => setOn(r.data.on)).catch(() => {}); }, [sid]);
  const flip = async (v) => {
    setOn(v);
    try { await http.put(`/students/${sid}/spanish`, { on: v }); toast.success(v ? `Spanish tap-to-translate is on for ${name}` : `Spanish help turned off for ${name}`); }
    catch (e) { setOn(!v); toast.error(formatApiError(e)); }
  };
  if (on === null) return null;
  return (
    <label className="flex items-center gap-3 rounded-2xl border border-[#E6DEC3] bg-white/80 px-4 py-3" data-testid={`spanish-default-${sid}`}>
      <Languages className="w-4 h-4 text-[#C87D53]" />
      <span className="flex-1 text-sm text-[#2C4A3E]"><b>Spanish help</b><span className="block text-xs text-stone-500">{name} can tap any word in lessons, quizzes, journals and Buddy chat to see it in Spanish.</span></span>
      <Switch checked={on} onCheckedChange={flip} data-testid={`spanish-default-switch-${sid}`} />
    </label>
  );
};
